import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from '@app/shared/shared.module';
import {EndUserSearchComponent} from './end-user-search/end-user-search.component';
import {OrganizationEditorComponent} from './organization-editor/organization-editor.component';
import {OrganizationSearchComponent} from './organization-search/organization-search.component';
import {ServiceProviderRoutingModule} from './service-provider-routing.module';
import {ServiceProvidersComponent} from './service-providers.component';
import {ServiceNumberSearchComponent} from './service-number-search/service-number-search.component';
import {ServiceNumberEditorComponent} from './service-number-editor/service-number-editor.component';
import {EndUserEditorComponent} from './end-user-editor/end-user-editor.component';
import {EndUserTerminalListComponent} from '@app/service-provider/end-user-terminal-list/end-user-terminal-list.component';
import {EndUserTerminalEditorComponent} from './end-user-terminal-editor/end-user-terminal-editor.component';

@NgModule({
  imports: [CommonModule, ServiceProviderRoutingModule, SharedModule],
  declarations: [
    ServiceProvidersComponent,
    EndUserSearchComponent,
    OrganizationSearchComponent,
    OrganizationEditorComponent,
    ServiceNumberSearchComponent,
    ServiceNumberEditorComponent,
    EndUserEditorComponent,
    EndUserTerminalListComponent,
    EndUserTerminalEditorComponent
  ]
})
export class ServiceProviderModule {}
